//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    hintLabel: String,
    hints: Array
  },
  data () {
    return {
      hintNumber: 0,
      polling: null
    }
  },
  beforeDestroy () {
    clearInterval(this.polling)
  },
  created () {
    this.pollData()
  },
  methods: {
    pollData () {
      this.polling = setInterval(() => {
        if (this.canIncrementHintNumber()) {
          this.incrementHintNumber()
        } else {
          this.hintNumber = 0
        }
      }, 4000)
    },
    numberOfHints () {
      return this.hints.length
    },
    canIncrementHintNumber () {
      return this.hintNumber + 1 < this.hints.length
    },
    canDecrementHintNumber () {
      return this.hintNumber > 0
    },
    incrementHintNumber () {
      this.hintNumber += 1
    },
    decrementHintNumber () {
      this.hintNumber -= 1
    }
  }
}

